<template>
  <div>
    <div class="modal-header">
      <h3
        class="modal-title"
      >Сессия ( Начало : {{currentZReport.startDate }} - Конец : {{ currentZReport.endDate }})</h3>
      <!--			<button type="button" @click="close" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>-->
    </div>
    <div class="modal-boy" id="toPrintZReport">
      <div class="row">
        <div class="col-sm-12">
          <div class="modal-body box-z-report">
            <template v-if="currentZReport.totalWithoutDiscount != 0">
              <table class="table table-striped table-bordered">
                <tbody>
                  <tr v-for="(key,index) in currentZReport.payments" :key="index">
                    <td v-if="index==='QARZGA' && key > 0">В Долг</td>
                    <td v-if="index==='HOMIYLIK' && key > 0">Спонсорство</td>
                    <td v-if="index==='CERTIFICATE' && key > 0">Сертификат</td>
                    <td v-if="index==='CASH' && key > 0">Наличные деньги</td>
                    <td v-if="index==='BANK_CARD' && key > 0">Банковская карта</td>
                    <td v-if="index==='BANK_TRANSFER' && key > 0">Перечисления</td>

                    <td v-if="index !== 'PAID' && key > 0">
                      <span class="display_currency" data-currency_symbol="true">
                        {{ key | currency({
                        symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
                        thousandsSeparator: ' '
                        }) }}
                      </span>
                    </td>
                  </tr>
                  <tr class="success">
                    <th>Общая сумма</th>
                    <td>
                      <b>
                        <span class="display_currency" data-currency_symbol="true">
                          {{ currentZReport.totalWithoutDiscount | currency({
                          symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
                          thousandsSeparator: ' '
                          }) }}
                        </span>
                      </b>
                    </td>
                  </tr>
<!--                  <tr class="success">-->
<!--                    <th>Общая сумма со скидкой</th>-->
<!--                    <td>-->
<!--                      <b>-->
<!--                        <span class="display_currency" data-currency_symbol="true">-->
<!--                          {{ currentZReport.totalWithDiscount | currency({-->
<!--                          symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',-->
<!--                          thousandsSeparator: ' '-->
<!--                          }) }}-->
<!--                        </span>-->
<!--                      </b>-->
<!--                    </td>-->
<!--                  </tr>-->
                  <tr class="success">
                    <th>Общая сумма возврата</th>
                    <td>
                      <b>
                        <span class="display_currency" data-currency_symbol="true">
                          {{ currentZReport.totalRefundAmount | currency({
                          symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
                          thousandsSeparator: ' '
                          }) }}
                        </span>
                      </b>
                    </td>
                  </tr>
                  <tr class="success">
                    <th>Общая сумма касса</th>
                    <td>
                      <b>
                        <span class="display_currency" data-currency_symbol="true">
                          {{currentZReport.totalWithDiscount- currentZReport.totalRefundAmount | currency({
                          symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
                          thousandsSeparator: ' '
                          }) }}
                        </span>
                      </b>
                    </td>
                  </tr>
<!--                  <tr class="success">-->
<!--                    <th>Общая сумма скидки</th>-->
<!--                    <td>-->
<!--                      <b>-->
<!--                        <span class="display_currency" data-currency_symbol="true">-->
<!--                          {{currentZReport.totalDiscount | currency({-->
<!--                          symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',-->
<!--                          thousandsSeparator: ' '-->
<!--                          }) }}-->
<!--                        </span>-->
<!--                      </b>-->
<!--                    </td>-->
<!--                  </tr>-->
                  <tr class="success">
                    <th>Общая кол-во товаров</th>
                    <td>
                      <b>
                        <span
                          class="display_currency"
                          data-currency_symbol="true"
                        >{{ currentZReport.count }}</span>
                      </b>
                    </td>
                  </tr>
                  <tr class="success">
                    <th>Общая кол-во возврат товаров</th>
                    <td>
                      <b>
                        <span
                          class="display_currency"
                          data-currency_symbol="true"
                        >{{ currentZReport.refundCount }}</span>
                      </b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </template>
            <template v-else>
              <b-alert variant="info" show>Продажи еще не сделаны</b-alert>
            </template>
          </div>
        </div>
        <div class="col-sm-12">
          <b>Кассир:</b>
          {{ currentZReport.cashierFullName }}
          <br />
        </div>
      </div>
    </div>
    <div class="modal-footer pb-0 hidden-print">
      <!--		<button type="submit"  class="btn btn-primary" id="pos-save">Распечатать</button>-->
      <button type="button" @click="close" class="btn btn-default" data-dismiss="modal">Закрыть</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { TokenService } from "../../../../../services/storage.service";

export default {
  name: "ZetReport",

  async created() {
    await this.getCurrentZReport(localStorage.getItem('dep_id'));
  },

  computed: {
    ...mapState(["userDepCurrencyName"]),
    ...mapState("zetReport", ["currentZReport"])
  },

  methods: {
    ...mapActions("zetReport", ["getCurrentZReport"]),
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.box-z-report {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
  padding: 10px;
}

.alert {
  padding: 15px;
}
</style>
